import { waitForImageLoad } from "./utils.js";
import RemixEditor from './editor.js';
import { RemixDocument, CanvasLayerImage } from "./remix-document.js";

class App
{
    constructor()
    {
    }

    async start()
    {
        // popstate/hashchange
        window.addEventListener("popstate", () => {
            console.log("popstate");
            this._loadFromHash();
        });
        this._loadFromHash();
    }

    async _loadFromHash()
    {
        if(this.remixEditor)
        {
            this.remixEditor.shutdown();
            this.remixEditor = null;
            this.remixDocument = null;
        }

        let imageId = document.location.hash.slice(1);
        console.log("Loading image ID:", imageId);

        // Load the base image so we can get its size.
        let img = new Image();
        img.src = `image/${imageId}`;
        try {
            await waitForImageLoad(img);
        } catch(e) {
            console.error("Error loading image:", e);
            alert("Error loading image");
            return;
        }
    
        // Decide on the canvas size based on the input image.  This is fixed and doesn't
        // rescale if the window is resized, so we give a consistent output size.  Use the
        // input image's aspect ratio with a pixel count of 1024^2.  Allow upscaling if it's
        // smaller, so higher-res emotes can be used with small images.
        let maxPixels = 1024 * 1024;
        let imgAspectRatio = img.naturalWidth / img.naturalHeight;
        let width = Math.sqrt(maxPixels * imgAspectRatio);
        let height = width / imgAspectRatio;
        width = Math.floor(width);
        height = Math.floor(height);
    
        this.remixDocument = new RemixDocument({ width, height });
    
        let imageLayer = new CanvasLayerImage({
            name: "image",
            src: img.src,
            width, height,
            fixed: true, // don't delete the background
        });
        this.remixDocument.addLayer(imageLayer);
    
        // Don't allow undoing the initial document.
        this.remixDocument.clearUndo();
    
        this.remixEditor = new RemixEditor({ remixDocument: this.remixDocument });

        window.addEventListener("keypress", (e) => {
            console.log(e.code, e.ctrlKey, e.metaKey);
            if(e.code === "KeyZ" && (e.ctrlKey || e.metaKey))
                this.remixDocument.undo();
            else if(e.code === "KeyY" && (e.ctrlKey || e.metaKey))
                this.remixDocument.redo();
        });
    }
}

let app = new App();
app.start();
